import { getDateString } from "common/date-utils";
import { AuxDatePickerDateFormatEnum } from "@blk/aladdin-web-components";
import { AuxFacetedFilterOptionTypeEnum } from "./types";
const filterSelectedOnlyDateRange = (d, fieldValues) => {
    const startDate = new Date(getDateString(d.startDateValue ?? undefined, AuxDatePickerDateFormatEnum.DD_MM_YYYY));
    const endDate = new Date(getDateString(d.endDateValue ?? undefined, AuxDatePickerDateFormatEnum.DD_MM_YYYY));
    if (fieldValues?.startDate && fieldValues.endDate && startDate && endDate) {
        return d;
    }
    return null;
};
const filterSelectedMultiSelect = (d, fieldValues) => {
    const matchedValues = d.values.filter((v) => v.codes && v.codes.length > 0 && fieldValues.includes(v.codes[0]));
    return matchedValues.length > 0 ? { ...d, values: matchedValues } : null;
};
const filterSelectedPicklist = (d, fieldValues) => {
    const matchedData = d.data
        .map((item) => {
        const selectedChildren = item.children
            ? item.children.filter((child) => fieldValues.includes(`${item.uid};${child.uid}`))
            : undefined;
        return fieldValues.includes(`${item.uid}`) || (selectedChildren && selectedChildren.length > 0)
            ? { ...item, children: selectedChildren }
            : null;
    })
        .filter((item) => item !== null);
    return matchedData.length > 0 ? { ...d, data: matchedData } : null;
};
export const filterSelectedOnlyData = (d, values) => {
    if (d.type === AuxFacetedFilterOptionTypeEnum.MultiSelect && d.values && Array.isArray(values[d.field])) {
        return filterSelectedMultiSelect(d, values[d.field]);
    }
    if (d.type === AuxFacetedFilterOptionTypeEnum.PickList && d.data && Array.isArray(values[d.field])) {
        return filterSelectedPicklist(d, values[d.field]);
    }
    if (d.type === AuxFacetedFilterOptionTypeEnum.DateRange) {
        return filterSelectedOnlyDateRange(d, values[d.field]);
    }
    if (values[d.field] === undefined) {
        return null;
    }
    return d;
};
export const filterSelectedOnlyFilters = (_filters, values) => {
    let filters = _filters.map((f) => ({
        ...f,
        data: f.data.map((d) => filterSelectedOnlyData(d, values)).filter((d) => d !== null)
    }));
    filters = filters.filter((f) => f.data.length > 0);
    return filters;
};
